// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"; // ✅ מוסיפים אימות
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCn_2pzvTHIFY4--JGb5X_YdlQhaXe1Np4",
  authDomain: "lutology-8db67.firebaseapp.com",
  projectId: "lutology-8db67",
  storageBucket: "lutology-8db67.firebasestorage.app",
  messagingSenderId: "783036470049",
  appId: "1:783036470049:web:57ffc1062b313728b6a460",
  measurementId: "G-G4FJDY36SB",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
